import React, { useState } from "react";
import {
  IconBookFlipPage,
  IconInformationCircle,
  IconBookChapter
} from "@americanbible/uikit";

import { TabSelectDropdownMenu } from "../TabSelectDropdownMenu/TabSelectDropdownMenu";
import { TabSelectMenuGridPane } from "../TabSelectDropdownMenu/TabSelectMenuGridPane";
import { TabSelectMenuListPane } from "../TabSelectDropdownMenu/TabSelectMenuListPane";
import { getMaxTabMenuHeight } from "../utils";
import { ListItem, ChapterListItem } from "../ListItems";

export const AllBookChapterList = ({ books, chapter, handleChapterClick }) => {
  const [activeMenuKey, setActiveMenuKey] = useState("books");
  const [activeBookId, setActiveBookId] = useState(
    chapter.getCurrentChapter().bookId
  );

  const bookMenu = books.map(book => ({
    key: book.id,
    onSelect: () => {
      setActiveBookId(book.id);
      setActiveMenuKey("chapters");
    },
    searchValues: [book.abbreviation, book.name],
    render: props => <ListItem {...props}>{book.name}</ListItem>
  }));

  const chapterMenu = books
    .find(({ id }) => id === activeBookId)
    .chapters.map(chapter => ({
      key: chapter.id,
      onSelect: () => handleChapterClick(chapter),
      searchValues: [chapter.number],
      render: props => (
        <ChapterListItem {...props}>
          {chapter.number === "intro" ? (
            <IconInformationCircle />
          ) : (
            chapter.number
          )}
        </ChapterListItem>
      )
    }));

  const maxListHeight = getMaxTabMenuHeight();

  return (
    <TabSelectDropdownMenu
      activeMenuKey={activeMenuKey}
      onTabClick={menuKey => setActiveMenuKey(menuKey)}
      menus={[
        {
          tab: <IconBookFlipPage />,
          tabPaneComponent: props => (
            <TabSelectMenuListPane {...props} maxListHeight={maxListHeight} />
          ),
          key: "books",
          activeMenuItemIndex: bookMenu.findIndex(
            ({ key }) => key === activeBookId
          ),
          menuItems: bookMenu
        },
        {
          tab: <IconBookChapter />,
          tabPaneComponent: props => (
            <TabSelectMenuGridPane {...props} maxListHeight={maxListHeight} />
          ),
          key: "chapters",
          activeMenuItemIndex: bookMenu.findIndex(({ key }) => true),
          menuItems: chapterMenu
        }
      ]}
    />
  );
};
